import { ItemListElements } from '@/types';

export function setItemListElements(items: ItemListElements[]) {
  if (items && items.length) {
    return items.map(item => ({
      '@type': 'ListItem',
      item: {
        '@id': item.item,
        name: item.name,
      },
      position: item.position,
    }));
  }

  return undefined;
}
